export default "__VITE_ASSET__BM6gLEAl__"